import React, { useEffect, useState } from 'react';
import { generateXMLSitemap } from '@/utils/seoEnhancements';

const SitemapXMLFeed: React.FC = () => {
  const [xmlContent, setXmlContent] = useState<string>('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const generateSitemap = async () => {
      try {
        const xml = await generateXMLSitemap();
        setXmlContent(xml);
        setLoading(false);

        // Clear the body and replace with raw XML
        document.body.innerHTML = '';
        document.body.style.fontFamily = 'monospace';
        document.body.style.whiteSpace = 'pre-wrap';
        document.body.style.fontSize = '12px';
        document.body.style.lineHeight = '1.4';
        document.body.style.padding = '0';
        document.body.style.margin = '0';
        document.body.textContent = xml;

        // Set proper content type
        document.title = 'Sitemap';
        
        // Try to set content type header (limited in browser)
        const metaContentType = document.querySelector('meta[http-equiv="Content-Type"]');
        if (metaContentType) {
          metaContentType.setAttribute('content', 'application/xml; charset=utf-8');
        } else {
          const newMeta = document.createElement('meta');
          newMeta.setAttribute('http-equiv', 'Content-Type');
          newMeta.setAttribute('content', 'application/xml; charset=utf-8');
          document.head.appendChild(newMeta);
        }
      } catch (error) {
        console.error('Error generating sitemap:', error);
        document.body.textContent = 'Error generating sitemap';
        setLoading(false);
      }
    };

    generateSitemap();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        fontFamily: 'monospace', 
        whiteSpace: 'pre-wrap', 
        padding: '20px',
        fontSize: '12px'
      }}>
        Generating sitemap...
      </div>
    );
  }

  // This component handles rendering via useEffect
  return null;
};

export default SitemapXMLFeed;